export default "__VITE_PUBLIC_ASSET__d4f8c1be__"